module.exports = __webpack_public_path__ + "img/tittle3.0cef0f43.png";